import { Component, OnDestroy, OnInit } from '@angular/core';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {

  loginForm: FormGroup;
  isLoginError = false;
  loginMsg = "";
  loginService_: any;
  display = false;
  showPassword = false;
  googleauthuri: SafeResourceUrl;
  assessmentid: number;
  moduleid: number;
  batchid: number;
  rootAdmin: string;
  // held so ngOnDestroy can remove the same reference addEventListener was given
  private boundReceiveCredMessage = this.receiveCredMessage.bind(this);

  constructor(private loginService: UseraccessserviceService, private router: Router, private activatedroute: ActivatedRoute,
    private schoolmanager: SchoolmanagementService, private headerservice: ComponentheaderService, private sanitizer: DomSanitizer,
    private toastr: ToastrService) {
      this.googleauthuri = this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.ImpataAppDomainUrl}/googleauth`); // source of iframe
      this.loginService_ = loginService;
      this.loginForm = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.email]),
        password: new FormControl('', [Validators.required]),
      });
  }

  updateLoadScreen(val: boolean) {
    this.loginService.isLoading = val;
    if (val) {
      this.loginForm.disable();
    } else {
      this.loginForm.enable();
    }
  }

  async OnSubmit() {
    if (!this.loginForm.valid) {
      return;
    }

    const email = this.loginForm.get('email').value;
    const password = this.loginForm.get('password').value;

    this.updateLoadScreen(true);
    this.isLoginError = false;

    try{
        const data: any = await this.loginService.userAuthentitcation(email, password, this.rootAdmin == '1').toPromise();
        this.loginService.setAuthenticatedUserToken(data.token);

        // redirect to dashboard, if no registered course... redirect to schoolhome
        if (this.activatedroute.snapshot.queryParams.url) {
          this.router.navigateByUrl(this.activatedroute.snapshot.queryParams.url);
        }
        else if(data.firstTime){
          window.location.href = '/user/dashboard';
        }
          else if(this.assessmentid > 0 && this.moduleid > 0){
          window.location.href = '/user/studentassesment?aid=' + this.assessmentid + '&classid=' + this.moduleid + '&batchid=' + this.batchid + '&target=1';
        }
        else{
          window.location.href = '/';
        }

        this.updateLoadScreen(false);
    }
    catch(err){
      console.log(err)
        this.isLoginError = true;
        this.loginMsg = this.readErrorMessage(err);
        this.updateLoadScreen(false);
    }
  }

  // the API returns { message } with a 400 on a failed authentication
  private readErrorMessage(err: any): string {
    if (err?.status === 0) {
      return "Unable to reach the server. Please check your connection and try again.";
    }
    return err?.error?.message || "Email or password is incorrect";
  }

  async ngOnInit() {
    this.headerservice.setPageTitle('Login');
    window.addEventListener('message', this.boundReceiveCredMessage, false);
    this.activatedroute.queryParams.subscribe(params => {
      const myQueryParam = params['redirect'];
      if (myQueryParam === "studentassesment"){
        this.assessmentid = params["aid"];
        this.moduleid = params["classid"];
        this.batchid = params["batchid"];
      }

    if (this.activatedroute.snapshot.queryParams.from === 'courseinvite')
      this.toastr.info("An account with your email already exists");

    });
    this.rootAdmin = this.activatedroute.snapshot.queryParams.rootadmin;

    // the school is resolved from the Referer header, so it can legitimately come back
    // empty (no referrer, or a blacklisted subdomain). Always end up showing the form
    // rather than leaving the page blank.
    try {
      const schoolinfo: any = await this.schoolmanager.getSchoolFromSubdomain();
      if (schoolinfo?.loginURL) {
        window.location.href = schoolinfo.loginURL;
        return;
      }
      if (!schoolinfo) {
        this.toastr.warning("We could not identify this school. Please check the address you used to get here.");
      }
    }
    catch (err) {
      console.log(err);
      this.toastr.warning("We could not identify this school. Please check the address you used to get here.");
    }
    this.display = true;
  }

  async receiveCredMessage(event: MessageEvent){
    if (event.origin !== `${environment.ImpataAppDomainUrl}` && event.data.type !== 'GoogleCredentials') {
      return;
    }
    if (event.data.payload){
      try {
        this.loginService.userGoogleAuthentication(event.data.payload).subscribe(
          (data) => {
            this.navigateAfterGoogleAuth(data['token'], data['email']);
          }
        );
      } catch (error) {
        console.error("Request failed:", error);
      }
    }
  }

  navigateAfterGoogleAuth(token: string, email: string){
    try {
      this.loginService.updateUserPrivateSchool(email).toPromise();
      // store the token directly instead of handing it to the next page in the query
      // string, where it would persist in history, logs and the Referer header
      this.loginService.setAuthenticatedUserToken(token);
      const returnUrlString = this.activatedroute.snapshot.queryParams.url ? this.activatedroute.snapshot.queryParams.url : '';
      window.location.href = returnUrlString ? `/?url=${encodeURIComponent(returnUrlString)}` : '/';
    } catch (error) {
      console.error("Request failed:", error);
    }
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.boundReceiveCredMessage);
  }
}
